import React from 'react'
import "../../../styles/helpDeskStyle.css"
import diamond from "../../../assets/diamond_shine.svg"
import voice from "../../../assets/voice_chat.svg"
import interpreter from "../../../assets/interpreter_mode.svg"
import started from "../../../assets/image_63.svg"
import security from "../../../assets/image_64.svg"
import trouble from "../../../assets/image_62.svg"

const HelpDesk = () => {
    return (
        <div className='jobpost-dashboard' style={{ minHeight: "100vh", padding: "20px", marginTop: "91px", display: "flex", flexDirection: "column", gap: "10px" }}>
            <div className='helpdesk-uppar-section'>
                <div className='helpdesk-first'>
                    <p className='team-staut-heading'>Help Desk</p>
                    <div className="interview-team-container" style={{ marginTop: "0px" }}>
                        <div
                            className='interview-team-box' style={{ flexDirection: "row", alignItems: "center" }}
                        //className={`team-box ${currentFilter === item.role ? 'active-filter' : ''}`}
                        // onClick={() => handleStatusFilter(item.role)}
                        >
                            <div className='team-content'>
                                <p className='interview-time'>28 Feb 2025, 07:00pm</p>
                                <p className='interview-title'>Issue: Dashboard Rel..</p>
                                <p className='interview-company'>Help Ticket 388NN87</p>
                            </div>
                            <span className="navigate-icon">{">"}</span>
                        </div>
                        <div
                            className='interview-team-box' style={{ flexDirection: "row", alignItems: "center" }}
                        //className={`team-box ${currentFilter === item.role ? 'active-filter' : ''}`}
                        // onClick={() => handleStatusFilter(item.role)}
                        >
                            <div className='team-content'>
                                <h3 className="team-name">+3</h3>
                                <p className='interview-title'>More Help Ticket</p>
                            </div>
                            <span className="navigate-icon">{">"}</span>
                        </div>
                    </div>
                </div>
                <div className="helpdesk-second">
                    <div className="prblm-container">
                        {[
                            {
                                title: "Getting started",
                                icon:started,
                                image:diamond,
                            },
                            {
                                title: "Security & Protection",
                                icon: security,
                                image:voice
                            },
                            {
                                title: "Troubleshooting & Support",
                                icon: trouble,
                                image:interpreter
                            },
                        ].map((item, idx) => (
                            <div
                                className={`helpdesk-card ${item.border ? "active" : ""}`}
                                key={idx}
                            >

                               <div className='helpdesk-circle'>
                                <img src={item.image} className='reative-images'/>
                               </div>
                                <h4> <img src={item.icon} className="helpdesk-card-icon"/>{item.title}</h4>
                                <hr style={{width:"100%",border: "1px solid rgba(239, 240, 240, 1)"}}/>
                                <a href="#" className="see-details">
                                    See details →
                                </a>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
            <div className='helpdesk-lower-section'>
                <p className='helpdesk-head'>Get the help you need</p>
                <p className='helpdesk-desc'>If you’re Feeling overwhelmed, remember You dont have to face it alone.
                    Reach out and get the help you need</p>
                <div className="helpdesk-form">
                    <form className="helpdesk-form-grid">
                        <div className="helpdesk-form-group">
                            <label>Help Ticket Name</label>
                            <input type="text" placeholder="Help me in billing status" />
                        </div>

                        <div className="helpdesk-form-group">
                            <label>Email</label>
                            <input type="email" placeholder="Brianfrederin@gmail.com" />
                        </div>

                        <div className="helpdesk-form-group">
                            <label>Priority</label>
                            <div className="priority-buttons">
                                <button type="button">High</button>
                                <button type="button" className="selected">Medium</button>
                                <button type="button">Low</button>
                            </div>
                        </div>

                        <div className="helpdesk-form-group">
                            <label>Ticket Type</label>
                            <select>
                                <option>Problem</option>
                                <option>Bug</option>
                                <option>Request</option>
                            </select>
                        </div>

                        <div className="helpdesk-form-group helpdesk-full-width">
                            <label>Message</label>
                            <textarea rows="5"></textarea>
                        </div>

                        <div className="helpdesk-form-group file-upload">
                            <label>Upload Attachment (optional)</label>
                            <div className="file-wrapper">
                                <input type="file" />
                            </div>
                        </div>

                        <div className="helpdesk-form-group submit-wrapper">
                            <button type="submit" className="helpdesk-submit-btn">Submit Request</button>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    )
}

export default HelpDesk